import { Link } from "react-router-dom";
import { ArrowRight, Stethoscope } from "lucide-react";
import { Button } from "@/components/ui/button";

export function FinalCtaSection() {
  return (
    <section className="border-t border-border py-20">
      <div className="container mx-auto px-4 text-center">
        <Stethoscope className="mx-auto h-9 w-9 text-primary" />
        <h2 className="mx-auto mt-6 max-w-3xl text-3xl font-bold sm:text-4xl">
          Haz que tu siguiente sesión de estudio tenga un objetivo concreto
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-muted-foreground">
          Elige una fuente, repasa un tema y mide qué necesitas volver a estudiar.
        </p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <a href="#precios">
            <Button size="lg">
              Ver planes
              <ArrowRight className="h-4 w-4" />
            </Button>
          </a>
          <Link to="/auth">
            <Button size="lg" variant="outline">
              Iniciar sesión
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
